import http, { BASE_URL_3, HttpSuccessOrErrorType, ListGetRequestParams, ListResults, OkPacket } from '../http';
import { Restaurant, GybDevice, GybThirdParty, Condition, RestaurantTunnelData, WarrantCode } from '../../models';
import { AxiosRequestConfig } from 'axios';
import { BindGybRegisterParam } from '../../models/fixed/bind-gyb-register';
import { getRBPStringId } from '../../page/main/main-page-states';

export default {
    /**
     * 条件查询Restaurant资源
     * @param params 参数
     */
    async get_restaurant_condition(params: Restaurant): Promise<HttpSuccessOrErrorType<ListResults<Restaurant>[]>> {
        return await http.get(`/restaurant/condition`, {
            params: {
                ...params
            },
        })
    },
    /**
     * RestaurantInfo
     * @param params 参数
     */
    async get_restaurant_info(_id: string, is_deleted?: boolean): Promise<HttpSuccessOrErrorType<Restaurant>> {
        return await http.get(`restaurant/_id/${_id}`, {
            params: {
                is_deleted
            }
        })
    },
    /**
     * 新建餐厅
     * @param params 参数
     */
    async create_restaurant(params: Restaurant): Promise<HttpSuccessOrErrorType<any>> {
        return await http.post(`/restaurant`, {
            ...params
        })
    },
    /**
     * 编辑餐厅
     * @param params 参数
     */
    async patch_restaurant_info(params: Restaurant, _id: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch(`/restaurant/_id/${_id}/info`, {
            ...params
        })
    },
    /**
     * 删除餐厅（软删）
     * @param params 参数
     */
    async delete_restaurant(ids: string[]): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/restaurant`, {
            data: {
                _id: ids
            }
        })
    },

    /**
     * 删除餐厅（硬删）
     * @param params 参数
     */
    async delete_restaurant_id_hard(id: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/restaurant/${id}/hard`, {
        })
    },

    /**
     * ADMIN上传餐厅信息
     * @param restaurantId 餐厅id
     * @param params 上传文件内容
     * @param config axios配置
     */
    async upload_restaurant_image_admin(restaurantId: string, params: any, config?: AxiosRequestConfig):
        Promise<{ result: any } | undefined> {
        const formData = new FormData()
        formData.append('', params)
        return (
            await http.patch(`/restaurant/_id/${restaurantId}/logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                ...config
            })
        );
    },
    /**
     * 获取餐厅logo
     * @param params 参数
     */
    async get_restaurant_logo(_id: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.get(`restaurant/_id/${_id}/logo`)
    },
    /**
     * 获取餐厅GYB
     * @param params 参数
     */
    async get_restaurant_gyb(params: { restaurant_id: string }): Promise<HttpSuccessOrErrorType<ListResults<GybDevice>[]>> {
        return await http.get(`/gyb/gyb_device/condition`, {
            params: {
                ...params
            }
        })
    },
    /**
     * 获取密钥
     * @param params 参数
     */
    async get_third_party_reseller(): Promise<HttpSuccessOrErrorType<ListResults<GybThirdParty>[]>> {
        return await http.get(`/gyb/third_party/condition`)
    },
    /**
     * 注册、绑定设备（餐厅）
     * @param params 参数
     */
    async bind_gyb_register(params: BindGybRegisterParam): Promise<HttpSuccessOrErrorType<any>> {
        return await http.post(`/gyb/register`, {
            ...params
        }, {
            timeout: 30000
        }
        )
    },
    /**
     * 删除GYB
     * @param params 参数
     */
    async delete_gyb_device(ids: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/gyb/gyb_device/${ids}`, {
            data: {
                _id: ids
            }
        })
    },
    /**
     * 获取GYB设备餐厅税务信息
     * @param params 参数
     */
    async get_gyb_restaurant_condition(params: { restaurant_string_id: string }): Promise<HttpSuccessOrErrorType<ListResults<GybDevice>[]>> {
        return await http.get(`/gyb/gyb_restaurant/condition`, {
            params: {
                ...params
            }
        })
    },

    /**
     * 批量删除餐厅
     * @param params 参数
     */
    async delete_restaurant_hard(ids: Array<string>): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/restaurant/hard`, {
            data: {
                _id: ids
            }
        })
    },

    /**
     * 新建密钥
     * @param params 参数
     */
    async post_restaurant_string_id_secret_key(string_id: string, name: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.post(`/restaurant/${string_id}/secret_key`, {
            name
        })
    },
    /**
     * 餐厅更改所属集团时修改密钥和公钥
     * @param params 参数
     */
    async patch_restaurant_private_key(params: Pick<Restaurant, 'private_key' | 'string_id' | 'belonged_group'>, _id: string): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch(`/restaurant/_id/${_id}/private_key`, {
            ...params
        })
    },

    /**
     * 餐厅更改所属集团时修改密钥和公钥
     * @param params 参数
     */
    async get_restaurant_tunnel_management_condition(params: Restaurant & Condition): Promise<HttpSuccessOrErrorType<ListResults<RestaurantTunnelData>[]>> {
        return await http.get(`/restaurant/database/condition`, {
            params: {
                ...params
            }
        })
    },

    /**
     * 获取默认隧道配置
     */
    async get_restaurant_tunnel_default(): Promise<{ database_host: string, database_port: number }> {
        return await http.get(`/restaurant/default/tunnel`)
    },



    /**
     * 获取相关加入/未加入isv的餐馆信息
     * @param params
     * @returns
     */
    async get_related_isv_restaurants(params: {
        // 加入传true，未加入传false
        join_isv?: boolean;
        // 餐馆名称搜索
        nickname?: string;
        // 默认1
        pag_page?: number;
        // 默认100
        pag_per_page?: number;
        // 默认isv_connect_create(加入时间)
        sort_key?: string;
        // 默认-1
        sort_value?: number;
    }): Promise<HttpSuccessOrErrorType<ListResults<Restaurant>[]>> {
        return await http.get('/admin/relatedIsvRestaurants', {
            params
        })
    },

    /**
     * 加入ISV
     * @param data
     * @returns
     */
    async patch_restaurant_manual_join_isv(data: {
        // isv信息
        joinIsvInfo: Array<{
            string_id: string;
            isv_fee: number
        }>
    }): Promise<HttpSuccessOrErrorType<OkPacket>> {
        return await http.patch('/restaurant/manual/join/isv', data)
    },


    /**
     * 获取websocket连接的项目
     * @param secretKey 
     * @returns 
     */
    async get_websocket_connected_projects(params: GetWebsocketConnectedProjectsParams): Promise<HttpSuccessOrErrorType<ConnectedProject[]>> {
        return await http.get('/public/websocket/connected_projects', {
            params
        })
    },

    /**
     * 获取特定授权点在期的餐厅
     * @param params 
     * @returns 
     */
    async get_restaurant_tunnel_management_condition_warrant(params: Restaurant & Condition, code: WarrantCode): Promise<HttpSuccessOrErrorType<ListResults<RestaurantTunnelData>[]>> {
        return await http.get(`/restaurant/warrants/${code}`, {
            params: {
                ...params
            }
        })
    },

    /**
     * 校验门店侧程序版本是否满足云端最低要求（`GET /v1/restaurant/{string_id}/version-check`）。
     * 与 **`GET /v3/check-permission/...`** 隧道校验独立；云 RBP / 菜单库在隧道通过后再调本接口做版本门禁。
     * @param restaurantStringId - 餐厅 `string_id`（路径参数）
     * @param config - Axios 可选配置（如 `cancelToken`，可与同轮隧道请求复用以在卸载时一并取消）
     */
    async get_restaurant_version_check(restaurantStringId: string, config?: AxiosRequestConfig): Promise<any> {
        const sid = (restaurantStringId && restaurantStringId.trim()) || '';
        return await http.get(`/restaurant/${encodeURIComponent(sid)}/version-check`, config);
    },

    /**
     * Deliverect未发送到Shark订单
     * @param params 
     * @returns 
     */
    async get_restaurant_d_order_condition(params: ListGetRequestParams<{
        string_id?: string[];
    }>): Promise<HttpSuccessOrErrorType<ListResults<UnSendOrderList>>> {
        return await http.get(`/restaurant/d_order/condition`, {
            params
        })
    },

    /**
     * 注册Fiskaly
     * @param data
     */
    async post_fiskaly_register(stringId: string, data: FiskalyRegisterParams): Promise<HttpSuccessOrErrorType<any>> {
        return await http.post(`/restaurant/${stringId}/create/fiskaly/manage_organization`, data)
    },

    /**
     * 绑定解绑 fiskaly_manage_organization_user_id
     * @param stringId 
     * @param data 
     * @returns 
     */
    async patch_fiskaly_manage_organization_user(stringId: string, data: FiskalyManageOrganizationUserIdParams): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch(`/restaurant/${stringId}/deal/fiskaly/manage_organization/user`, data)
    },

    /**
     * 上传fiskaly 协议
     * @param stringId 
     * @param file 
     * @returns 
     */
    async upload_fiskaly_agreement(stringId: string, file: File): Promise<HttpSuccessOrErrorType<{ url: string, filename: string }>> {
        const formData = new FormData();
        formData.append('file', file);
        return await http.post(`/restaurant/${stringId}/upload/restaurant-agreement`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    /**
     * 获取隐私协议
     * @param stringId 
     * @returns 
     */
    async get_privacy_policy(stringId: string): Promise<HttpSuccessOrErrorType<PrivacyPolicy>> {
        return await http.get(`/resturn/${stringId}/privacy_policy`)
    },

    /**
     * 生成分享链接
     * @param stringId 
     * @returns 
     */
    async post_share_link(stringId: string): Promise<HttpSuccessOrErrorType<ShareLink>> {
        return await http.get(`/${stringId}/agreement/generate-link`)
    },

    /**
     * 校验分享链接 token
     * @param params 
     * @returns 
     */
    async get_share_link(params: {
        password: string;
        t: string;
    }): Promise<HttpSuccessOrErrorType<ShareLinkValidate>> {
        return await http.get(`/agreement/validate-link`, {
            params
        })
    },

    /**
     * 无需登录的协议上传接口   
     * @param params 
     * @returns 
     */
    async upload_agreement({ file, t }: { file: File, t: string }): Promise<HttpSuccessOrErrorType<{ url: string, filename: string }>> {
        const formData = new FormData();
        formData.append('file', file);
        return await http.post(`/agreement/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            params: {
                t
            }
        })
    },

    // 根据邮编搜索市镇编码(INE)
    async get_municipality_by_postcode(postcode: string): Promise<HttpSuccessOrErrorType<MunicipalityResponse>> {
        return await http.get(`/municipios/${postcode}`)
    },

    /**
     * 云端餐厅信息（Staff 当前餐厅），GET /v3/cloud/restaurant-info/{string_id}
     */
    async get_cloud_restaurant_info(): Promise<HttpSuccessOrErrorType<Restaurant>> {
        return await http.get(`${BASE_URL_3}/cloud/restaurant-info/${getRBPStringId()}`)
    },

    /**
     * 更新餐厅「营业分析数据来源」（EFR/ECCO），后端据此判断营业分析查哪张表
     */
    async patch_cloud_analysis_origin(cloud_analysis_origin: 'EFR' | 'ECCO'): Promise<HttpSuccessOrErrorType<OkPacket>> {
        return await http.patch(
            `${BASE_URL_3}/restaurant-info/${getRBPStringId()}/analysis-origin`,
            { cloud_analysis_origin }
        )
    },

}


// 连接的应用 
export type ConnectedProject = {
    socket_id: string
    room: string;
    detailed: {
        ip: string
    };
    group_id: string;
    string_id: string;
    restaurant_name: string;
    group_name: string;
}

// 连接的应用 參數
export type GetWebsocketConnectedProjectsParams = {
    restaurant_name?: string[];
    group_name?: string[]
}

// 未发送的订单
export type UnSendOrderList = {
    string_id: string;
    order_id: string;
    order: object;
    _id: string;
}

// 注册 Fiskaly 參數
export type FiskalyRegisterParams = Pick<Restaurant, 'reg_name'
    | 'reg_vat_number'
    | 'reg_local'
    | 'reg_postcode'
    | 'reg_city'
    | 'reg_country'
    | 'reg_street_number'
    | 'reg_territory'
    | 'reg_municipality'
    | 'reg_state'
    | 'processing_mode'
    | 'fiskaly_environment'
    | 'reg_pec'
>;

// 邀请、删除 fiskaly_manage_organization_user_id 传参
export type FiskalyManageOrganizationUserIdParams = {
    fiskaly_manage_organization_id: string;
    // 邀请时候传
    reg_pec?: string;
    // 删除时候传
    fiskaly_manage_organization_user_id?: string;
    // 1:邀请 2:删除
    operate_type: string;
}


// 隐私协议返回值
export type PrivacyPolicy = {
    // 区域
    reg_territory?: string;
    // 商家声明
    restaurant_agreement?: string;
    // 商家声明（未签名）
    restaurant_unsigned_agreement?: string;
    //  "0"  未上传   "1" 已上传  
    fiskaly_upload_agreemen?: string;
    // 序列号
    fiskaly_serial_number?: string;
    // 责任声明
    policy?: Policy
}

// 责任声明

export type Policy = {
    // 公司名称
    company_legal_name?: string;
    // 公司税号
    company_tax_number?: string;
    // 许可证
    license?: string;
    // 名称
    name?: string;
    // 责任声明
    responsibility_declaration?: string;
    // 版本
    version?: string;
    // id
    _id?: string;
}

// 分享链接返回值
export type ShareLink = {
    // 过期时间
    expireAt?: string;
    // 是否更新
    isUpdated?: boolean;
    // 密码
    password?: string;
    // 分享链接
    shareUrl?: string;
    // 状态 ok
    status?: string;
}


// 校验分享链接返回值
export type ShareLinkValidate = {
    // 过期时间
    expireAt?: string;
    // 是否更新
    fiskaly_upload_agreemen?: string;
    // 是否需要密码
    passwordRequired?: boolean;
    // 协议
    restaurant_agreement?: string;
    // 状态
    status?: string;
    // 餐厅id
    string_id?: string;
    // token
    token?: string;
    // 商家声明（未签名）
    restaurant_unsigned_agreement?: string;
}



/**
 * 单条市镇数据结构
 * 基于西班牙 INE (Instituto Nacional de Estadística) 标准字段
 */
export interface MunicipalityItem {
    /** 自治区代码 (Código de Comunidad) */
    CCOM: string;

    /** 省份代码 (Código de Provincia) - 例如 "28" 代表马德里 */
    CPRO: string;

    /** 市镇代码缩写? (看起来像 CPRO + CMUM 组成了 MIR 的前几位) */
    CMUM: string;

    /** 完整市镇代码 (通常用于内部唯一标识) */
    CMUN: string;

    /** 市镇名称 (Denominación Municipio 50字以内) - 例如 "MADRID" */
    DMUN50: string;

    /** 市镇名称备选/别名 (可能为空字符串) */
    ALTERNATIVO_DMUN50: string;

    /** 综合代码 (MIR Code) - 看起来是 CPRO + CMUM 的组合 */
    MIR: string;

    /** 欧盟统计地域单位命名法 - 2级 (NUTS Level 2) */
    NUTS2: string;

    /** 欧盟统计地域单位命名法 - 3级 (NUTS Level 3) */
    NUTS3: string;

    /** 集体实体数量 (如果是 null，建议设为 number | null) */
    N_ENTIDADES_COLECTIVAS: number | null;

    /** 人口实体/居民点数量 */
    N_POBLACIONES: number;
}

/**
 * API 完整响应结构
 * 包含分页信息和数据列表
 */
export interface MunicipalityResponse {
    /** 下一页的 URL (如果没有则为 null) */
    next: string | null;

    /** 上一页的 URL (如果没有则为 null) */
    previous: string | null;

    /** 当前页码 */
    current_page: number;

    /** 当前页数据条数 */
    size: number;

    /** 数据列表 */
    data: MunicipalityItem[];

    /** 数据更新日期 (格式: YYYY.MM) */
    update_date: string;

    /** 警告信息 (通常为空字符串) */
    warning: string;
}
